import {useState, useEffect} from 'react';
import {
  AddBox as AddBoxIcon,
  GroupAdd as GroupAddIcon,
  Home as HomeIcon,
  Schedule as ScheduleIcon,
  //AddAlarm as ScheduleAddIcon,
  Settings as SettingsIcon,
  LocalDrink as LocalDrinkIcon,
} from '@material-ui/icons';
import Navigation from 'Navigation/Presentation/Navigation';
import {getMe} from 'Users/service/UserService';

const navTransitions = [
  {name: 'SBS Lobby', path: '/Sbss', icon: <HomeIcon />},
  {name: 'Schedule Lobby', path: '/Schedules', icon: <ScheduleIcon />},
  {name: 'Consumables & Units', path: '/Consumables', icon: <LocalDrinkIcon />},
  {name: 'Create: SBS', path: '/Sbss/create', icon: <AddBoxIcon />},
  // {
  //   name: 'Create: Schedule',
  //   path: '/Schedules/create',
  //   icon: <ScheduleAddIcon />,
  // },
  {name: 'Create: Team', path: '/Teams/create', icon: <GroupAddIcon />},
  {name: 'Permissions', path: '/Admin/Permissions', icon: <SettingsIcon />},
];

export default function NavigationContainer(props) {
  const [user, setUser] = useState({firstName: 'Unknown', lastName: 'User'});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const handleOpenDrawer = () => setDrawerOpen(true);
  const handleCloseDrawer = () => setDrawerOpen(false);

  useEffect(() => {
    const handleRetrieveUser = async () => {
      const user = await getMe();

      setUser(user);
    };

    if (user.firstName === 'Unknown') handleRetrieveUser();
  });

  return (
    <div>
      <Navigation
        {...props}
        user={user}
        navTransitions={navTransitions}
        drawerOpen={drawerOpen}
        onOpenDrawer={handleOpenDrawer}
        onCloseDrawer={handleCloseDrawer}
      />
    </div>
  );
}
